export default __webpack_public_path__ + "static/media/DE-PassengerApp-Logo.87348536.png";